import {DialogClose} from '@radix-ui/react-dialog';

export const INTRO_STEPS = [
  {
    ctaProps: {children: 'How it works', icon: 'ArrowRight' as const},
    headline: 'Take your Lifestyle Survey',
    lede: 'You’ll get an overall Lifestyle Score to see how well you’re doing across five main lifestyle categories. After receiving your TallyAge™, Tally members will also get a unique Action Plan with detailed, personalized recommendations.',
    imgSrcSet: ['/image/survey/intro1.svg', '/image/survey/intro1xl.svg'],
    showSkip: true,
  },
  {
    ctaProps: {children: 'Next'},
    headline: 'Our TallyAge™ Test was trained on 8,000+ people',
    lede: 'Our epigenetic clock algorithm used to calculate your TallyAge™ was developed on an 8,000+ person dataset that was highly diverse (over 30% non-white), contained similar numbers of men and women, and spanned a wide chronological age range of 18-100 years.',
    imgSrcSet: ['/image/survey/intro2.png', '/image/survey/intro2xl.png'],
    showSkip: true,
  },
  {
    ctaProps: {children: 'Next'},
    headline: 'Personalized recommendations from your TallyAge™',
    lede: 'Once we calculate your TallyAge™, we’ll analyze and compare your DNA methylation and lifestyle versus your peers to generate personalized recommendations for members designed to lower your TallyAge™.',
    imgSrcSet: ['/image/survey/intro3.jpg', '/image/survey/intro3xl.jpg'],
    showSkip: true,
  },
  {
    ctaProps: {children: 'Start the 5–min survey', icon: 'ArrowRight' as const, as: DialogClose},
    headline: 'Your TallyAge™ + Lifestyle Score paint a full picture',
    lede: 'After analyzing your DNA methylation profile for each test, we’ll use peer comparisons of TallyAge™ and scientific research to produce your unique Action Plan, with the long-term goal of maintaining a lower TallyAge™.',
    imgSrcSet: ['/image/survey/intro4.png', '/image/survey/intro4xl.png'],
    showSkip: false,
  },
];

export const CONTINUE_STEP = {
  ctaProps: {children: 'Continue the 5–min survey', icon: 'ArrowRight' as const, as: DialogClose},
  headline: 'Continue your Lifestyle Survey',
  lede: 'You’ll get an overall Lifestyle Score and see how well you’re doing across five main lifestyle categories. After you receive your TallyAge™, you’ll get more detailed, personalized recommendations in a unique Action Plan.',
  imgSrcSet: ['/image/survey/intro1.svg', '/image/survey/intro1xl.svg'],
  showSkip: false,
};
